import LinearPacing from "./LinearPacing";

export default LinearPacing;
